import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    // CLASS 3
    {
        id: 'resource-class3-1',
        name: (
            <FormattedMessage
                defaultMessage="Basic Computer and Identification of Prarambh Software"
                description="Resource name"
                id="gui.resources.class3.1"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Basic Computer and Identification of Prarambh Software.sb3',
        rawURL: '/static/resources/thumbnails/Basic Computer and Identification of Scratch Software.png'
    },
    {
        id: 'resource-class3-2',
        name: (
            <FormattedMessage
                defaultMessage=":Prarambh: Sprites, Backdrop, Blocks, Script Area"
                description="Resource name"
                id="gui.resources.class3.2"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Prarambh GUI_ Sprites, Backdrop, Blocks, Script Area.sb3',
        rawURL: '/static/resources/thumbnails/Scratch GUI.png'
    },
    {
        id: 'resource-class3-3',
        name: (
            <FormattedMessage
                defaultMessage="Hello program, Sprite Movement"
                description="Resource name"
                id="gui.resources.class3.3"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Hello program, Sprite Movement.sb3',
        rawURL: '/static/resources/thumbnails/Hello program, Sprite Movement.png'
    },
    {
        id: 'resource-class3-4',
        name: (
            <FormattedMessage
                defaultMessage="Fun with Paint"
                description="Resource name"
                id="gui.resources.class3.4"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Fun with Paint.sb3',
        rawURL: '/static/resources/thumbnails/Fun with Paint.png'
    },
    {
        id: 'resource-class3-5',
        name: (
            <FormattedMessage
                defaultMessage="Making a character dance"
                description="Resource name"
                id="gui.resources.class3.5"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Making a character dance.sb3',
        rawURL: '/static/resources/thumbnails/Making a character dance.png'
    },
    {
        id: 'resource-class3-6',
        name: (
            <FormattedMessage
                defaultMessage="Blink LED Uno"
                description="Resource name"
                id="gui.resources.class3.6"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/Blink LED Uno.sb3',
        rawURL: '/static/resources/thumbnails/Led blinking.png'
    },
    {
        id: 'resource-class3-9',
        name: (
            <FormattedMessage
                defaultMessage="AI object detection"
                description="Resource name"
                id="gui.resources.class3.9"
            />
        ),
        tags: ['class3'],
        featured: true,
        sourcePath: '/static/resources/programs/AI object detection.sb3',
        rawURL: '/static/resources/thumbnails/AI object detection.png'
    },

    // CLASS 4
    {
        id: 'resource-class4-1',
        name: (
            <FormattedMessage
                defaultMessage="Bouncing Ball Game"
                description="Resource name"
                id="gui.resources.class4.1"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Bouncing Ball Game.sb3',
        rawURL: '/static/resources/thumbnails/Bouncing Ball Game.png'
    },
    {
        id: 'resource-class4-2',
        name: (
            <FormattedMessage
                defaultMessage="Animated Story for two characters talking"
                description="Resource name"
                id="gui.resources.class4.2"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Animated Story for two characters talking.sb3',
        rawURL: '/static/resources/thumbnails/Animated Story for two characters talking.png'
    },
    {
        id: 'resource-class4-3',
        name: (
            <FormattedMessage
                defaultMessage="Math Quiz Builder"
                description="Resource name"
                id="gui.resources.class4.3"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Math Quiz Builder.sb3',
        rawURL: '/static/resources/thumbnails/Math Quiz Builder.png'
    },
    {
        id: 'resource-class4-4',
        name: (
            <FormattedMessage
                defaultMessage="Fan On and Off"
                description="Resource name"
                id="gui.resources.class4.4"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Fan On and Off.sb3',
        rawURL: '/static/resources/thumbnails/Fan On and Off.png'
    },
    {
        id: 'resource-class4-5',
        name: (
            <FormattedMessage
                defaultMessage="Light On and Off"
                description="Resource name"
                id="gui.resources.class4.5"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Light On and Off.sb3',
        rawURL: '/static/resources/thumbnails/Light On and Off.png'
    },
    {
        id: 'resource-class4-7',
        name: (
            <FormattedMessage
                defaultMessage="Home Multiple Lighting Control System"
                description="Resource name"
                id="gui.resources.class4.7"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Home Multiple Lighting Control System.sb3',
        rawURL: '/static/resources/thumbnails/Home Multiple Lighting Control System.png'
    },
    {
        id: 'resource-class4-8',
        name: (
            <FormattedMessage
                defaultMessage="Home Fan Speed Control System"
                description="Resource name"
                id="gui.resources.class4.8"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/Home Fan Speed Control System.sb3',
        rawURL: '/static/resources/thumbnails/Home Fan Speed Control System.png'
    },
    {
        id: 'resource-class4-9',
        name: (
            <FormattedMessage
                defaultMessage="AI - Home applicances Control using sound gesture"
                description="Resource name"
                id="gui.resources.class4.9"
            />
        ),
        tags: ['class4'],
        featured: true,
        sourcePath: '/static/resources/programs/AI - Home applicances ontrol using sound gesture.sb3',
        rawURL: '/static/resources/thumbnails/AI Home Appliances Control using sound gesture.png'
    },

    // CLASS 5
    {
        id: 'resource-class5-1',
        name: (
            <FormattedMessage
                defaultMessage="Smart Traffic Light Simulation"
                description="Resource name"
                id="gui.resources.class5.1"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Smart Traffic Light Simulation.sb3',
        rawURL: '/static/resources/thumbnails/Smart Traffic Light Simulation.png'
    },
    {
        id: 'resource-class5-2',
        name: (
            <FormattedMessage
                defaultMessage="Game on battle space"
                description="Resource name"
                id="gui.resources.class5.2"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Game on battle space.sb3',
        rawURL: '/static/resources/thumbnails/Game on battle space.png'
    },
    {
        id: 'resource-class5-3',
        name: (
            <FormattedMessage
                defaultMessage="Spinning Logo Animation"
                description="Resource name"
                id="gui.resources.class5.3"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Spinning Logo Animation.sb3',
        rawURL: '/static/resources/thumbnails/Spinning Logo Animation.png'
    },
    {
        id: 'resource-class5-4',
        name: (
            <FormattedMessage
                defaultMessage="Interactive Quiz Game"
                description="Resource name"
                id="gui.resources.class5.4"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Interactive Quiz Game.sb3',
        rawURL: '/static/resources/thumbnails/Interactive Quiz Game.png'
    },
    {
        id: 'resource-class5-5',
        name: (
            <FormattedMessage
                defaultMessage="Catch the Apple Game"
                description="Resource name"
                id="gui.resources.class5.5"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Catch the Apple Game.sb3',
        rawURL: '/static/resources/thumbnails/Catch the Apple Game.png'
    },
    {
        id: 'resource-class5-6',
        name: (
            <FormattedMessage
                defaultMessage="AI-based Sprite Movement with Hand Gesture"
                description="Resource name"
                id="gui.resources.class5.6"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/AI-based Sprite Movement with Hand Gesture.sb3',
        rawURL: '/static/resources/thumbnails/AI-based Sprite Movement with Hand Gesture.png'
    },
    {
        id: 'resource-class5-7',
        name: (
            <FormattedMessage
                defaultMessage="Light Sensor and Dark Detector Alert"
                description="Resource name"
                id="gui.resources.class5.7"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Light Sensor and Dark Detector Alert.sb3',
        rawURL: '/static/resources/thumbnails/LIGHT SENSOR AND DARK DETECTOR ALART.png'
    },
    {
        id: 'resource-class5-8',
        name: (
            <FormattedMessage
                defaultMessage="Temperature Sensor & Fire Alarm"
                description="Resource name"
                id="gui.resources.class5.8"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/Temperature Sensor & Fire Alarm.sb3',
        rawURL: '/static/resources/thumbnails/Temperature Sensor & Fire Alarm.png'
    },
    {
        id: 'resource-class5-9',
        name: (
            <FormattedMessage
                defaultMessage="AI hand Gesture Controlled Car Game"
                description="Resource name"
                id="gui.resources.class5.9"
            />
        ),
        tags: ['class5'],
        featured: true,
        sourcePath: '/static/resources/programs/AI hand Gesture Controlled Car Game.sb3',
        rawURL: '/static/resources/thumbnails/AI hand Gesture Controlled Car Game.png'
    },

    // CLASS 6
    {
        id: 'resource-class6-1',
        name: (
            <FormattedMessage
                defaultMessage="Snake Game"
                description="Resource name"
                id="gui.resources.class6.1"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Snake Game.sb3',
        rawURL: '/static/resources/thumbnails/Snake Game.png'
    },
    {
        id: 'resource-class6-2',
        name: (
            <FormattedMessage
                defaultMessage="Music Maker"
                description="Resource name"
                id="gui.resources.class6.2"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Music Maker.sb3',
        rawURL: '/static/resources/thumbnails/Music Maker.png'
    },
    {
        id: 'resource-class6-3',
        name: (
            <FormattedMessage
                defaultMessage="AI Chatbot (Basic)"
                description="Resource name"
                id="gui.resources.class6.3"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/AI Chatbot (Basic).sb3',
        rawURL: '/static/resources/thumbnails/AI Chatbot (Basic).png'
    },
    {
        id: 'resource-class6-4',
        name: (
            <FormattedMessage
                defaultMessage="Door Bell Alarm (Simulation)"
                description="Resource name"
                id="gui.resources.class6.4"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Door Bell Alarm.sb3',
        rawURL: '/static/resources/thumbnails/Door Bell Alarm (Scratch Simulation).png'
    },
    {
        id: 'resource-class6-5',
        name: (
            <FormattedMessage
                defaultMessage="Water Level Indicator + Alarm (Prarambh Simulation)"
                description="Resource name"
                id="gui.resources.class6.5"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Water Level Indicator + Alarm (Scratch Simulation).sb3',
        rawURL: '/static/resources/thumbnails/Water Level Indicator + Alarm (Scratch Simulation).png'
    },
    {
        id: 'resource-class6-6',
        name: (
            <FormattedMessage
                defaultMessage="AI Based Air Draw"
                description="Resource name"
                id="gui.resources.class6.6"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/AI Based Air Draw.sb3',
        rawURL: '/static/resources/thumbnails/Fun with Paint.png'
    },
    {
        id: 'resource-class6-7',
        name: (
            <FormattedMessage
                defaultMessage="Object detection Using PIR SENSOR"
                description="Resource name"
                id="gui.resources.class6.7"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Object detection Using PIR SENSOR.sb3',
        rawURL: '/static/resources/thumbnails/Object detection Using PIR SENSOR.png'
    },
    {
        id: 'resource-class6-8',
        name: (
            <FormattedMessage
                defaultMessage="Anti Theft Alarm using Touch Sensor"
                description="Resource name"
                id="gui.resources.class6.8"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Anti Theft Alarm using Touch Sensor.sb3',
        rawURL: '/static/resources/thumbnails/Anti Theft Alarm using Touch Sensor.png'
    },
    {
        id: 'resource-class6-9',
        name: (
            <FormattedMessage
                defaultMessage="Ai-Powered Door Unlocking System Using Face Detection"
                description="Resource name"
                id="gui.resources.class6.9"
            />
        ),
        tags: ['class6'],
        featured: true,
        sourcePath: '/static/resources/programs/Ai-Powered Door Unlocking System Using Face Detection.sb3',
        rawURL: '/static/resources/thumbnails/ai face door unlock.png'
    },

    // CLASS 7
    {
        id: 'resource-class7-1',
        name: (
            <FormattedMessage
                defaultMessage="Virtual Pet Game"
                description="Resource name"
                id="gui.resources.class7.1"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Virtual Pet Game.sb3',
        rawURL: '/static/resources/thumbnails/Virtual Pet Game.png'
    },
    {
        id: 'resource-class7-2',
        name: (
            <FormattedMessage
                defaultMessage="Paint Program with Tools"
                description="Resource name"
                id="gui.resources.class7.2"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Paint Program with Tools.sb3',
        rawURL: '/static/resources/thumbnails/Paint Program with Tools.png'
    },
    {
        id: 'resource-class7-3',
        name: (
            <FormattedMessage
                defaultMessage="Fruit Ninja Clone"
                description="Resource name"
                id="gui.resources.class7.3"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Fruit Ninja Clone.sb3',
        rawURL: '/static/resources/thumbnails/Fruit Ninja Clone.png'
    },
    {
        id: 'resource-class7-4',
        name: (
            <FormattedMessage
                defaultMessage="Flappy Bird Clone"
                description="Resource name"
                id="gui.resources.class7.4"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Flappy Bird Clone.sb3',
        rawURL: '/static/resources/thumbnails/Flappy Bird Clone.png'
    },
    {
        id: 'resource-class7-5',
        name: (
            <FormattedMessage
                defaultMessage="Simple Calculator"
                description="Resource name"
                id="gui.resources.class7.5"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Simple Calculator.sb3',
        rawURL: '/static/resources/thumbnails/Physics Engine Demo.png'
    },
    {
        id: 'resource-class7-7',
        name: (
            <FormattedMessage
                defaultMessage="Biosensor interface to measure the heart rate (BPM)"
                description="Resource name"
                id="gui.resources.class7.7"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Biosensor interface to measure the heart rate (BPM).sb3',
        rawURL: '/static/resources/thumbnails/Biosensor interface to measure the heart rate (BPM).png'
    },
    {
        id: 'resource-class7-8',
        name: (
            <FormattedMessage
                defaultMessage="Biosensor interface to measure the blood oxygen saturation (SpO₂)"
                description="Resource name"
                id="gui.resources.class7.8"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/Biosensor interface to measure the blood oxygen saturation (SpO₂).sb3',
        rawURL: '/static/resources/thumbnails/Biosensor interface to measure the blood oxygen saturation (SpO₂).png'
    },
    {
        id: 'resource-class7-9',
        name: (
            <FormattedMessage
                defaultMessage="AI Virtual Doctor"
                description="Resource name"
                id="gui.resources.class7.9"
            />
        ),
        tags: ['class7'],
        featured: true,
        sourcePath: '/static/resources/programs/AI Virtual Doctor.sb3',
        rawURL: '/static/resources/thumbnails/AI Virtual Doctor.png'
    },

    // CLASS 8
    {
        id: 'resource-class8-1',
        name: (
            <FormattedMessage
                defaultMessage="Endless Runner Game"
                description="Resource name"
                id="gui.resources.class8.1"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Endless Runner Game.sb3',
        rawURL: '/static/resources/thumbnails/Endless Runner Game.png'
    },
    {
        id: 'resource-class8-2',
        name: (
            <FormattedMessage
                defaultMessage="Typing Speed Test"
                description="Resource name"
                id="gui.resources.class8.2"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Typing Speed Test.sb3',
        rawURL: '/static/resources/thumbnails/Typing Speed Test.png'
    },
    {
        id: 'resource-class8-3',
        name: (
            <FormattedMessage
                defaultMessage="Weather Simulator"
                description="Resource name"
                id="gui.resources.class8.3"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Weather Simulator.sb3',
        rawURL: '/static/resources/thumbnails/Weather Simulator.png'
    },
    {
        id: 'resource-class8-4',
        name: (
            <FormattedMessage
                defaultMessage="Virtual Doctor"
                description="Resource name"
                id="gui.resources.class8.4"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Virtual Doctor.sb3',
        rawURL: '/static/resources/thumbnails/Watering Plant (Scratch Simulation).png'
    },
    {
        id: 'resource-class8-5',
        name: (
            <FormattedMessage
                defaultMessage="Crop Growth (Prarambh Simulation)"
                description="Resource name"
                id="gui.resources.class8.5"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Crop Growth (Scratch Simulation).sb3',
        rawURL: '/static/resources/thumbnails/Crop Growth (Scratch Simulation).png'
    },
    {
        id: 'resource-class8-7',
        name: (
            <FormattedMessage
                defaultMessage="Soil Moisture Sensor interface for Smart Irrigation"
                description="Resource name"
                id="gui.resources.class8.7"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Soil Moisture Sensor interface for Smart Irrigation.sb3',
        rawURL: '/static/resources/thumbnails/Soil Moisture Sensor interface for Smart Irrigation.png'
    },
    {
        id: 'resource-class8-8',
        name: (
            <FormattedMessage
                defaultMessage="Submersible Pump interface for Smart Irrigation"
                description="Resource name"
                id="gui.resources.class8.8"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/Submersible Pump interface for Smart Irrigation.sb3',
        rawURL: '/static/resources/thumbnails/Submersible Pump interface for Smart Irrigation.png'
    },
    {
        id: 'resource-class8-9',
        name: (
            <FormattedMessage
                defaultMessage="AI Chat Bot"
                description="Resource name"
                id="gui.resources.class8.9"
            />
        ),
        tags: ['class8'],
        featured: true,
        sourcePath: '/static/resources/programs/AI Chat Bot.sb3',
        rawURL: '/static/resources/thumbnails/Ai chat bot.png'
    },

    // CLASS 9
    {
        id: 'resource-class9-1',
        name: (
            <FormattedMessage
                defaultMessage="Memory Matching Game"
                description="Resource name"
                id="gui.resources.class9.1"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Memory Matching Game.sb3',
        rawURL: '/static/resources/thumbnails/Memory Matching Game.png'
    },
    {
        id: 'resource-class9-2',
        name: (
            <FormattedMessage
                defaultMessage="Clock with Timer"
                description="Resource name"
                id="gui.resources.class9.2"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Clock with Timer.sb3',
        rawURL: '/static/resources/thumbnails/Clock with Timer.png'
    },
    {
        id: 'resource-class9-3',
        name: (
            <FormattedMessage
                defaultMessage="Weather Monitoring and Reporting System"
                description="Resource name"
                id="gui.resources.class9.3"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Weather Monitoring and Reporting System.sb3',
        rawURL: '/static/resources/thumbnails/Weather Monitoring.png'
    },
    {
        id: 'resource-class9-4',
        name: (
            <FormattedMessage
                defaultMessage="Environmental Pollution (Prarambh Simulation)"
                description="Resource name"
                id="gui.resources.class9.4"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Environmental Pollution (Scratch Simulation).sb3',
        rawURL: '/static/resources/thumbnails/Weather Simulator.png'
    },
    {
        id: 'resource-class9-5',
        name: (
            <FormattedMessage
                defaultMessage="Climate Change (Prarambh Simulation)"
                description="Resource name"
                id="gui.resources.class9.5"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Climate Change (Scratch Simulation).sb3',
        rawURL: '/static/resources/thumbnails/Climate Change (Scratch Simulation).png'
    },
    {
        id: 'resource-class9-7',
        name: (
            <FormattedMessage
                defaultMessage="Voice Controlled Robot Movement"
                description="Resource name"
                id="gui.resources.class9.7"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Voice Controlled Robot Movement.sb3',
        rawURL: '/static/resources/thumbnails/Voice Controlled Robot Movement.png'
    },
    {
        id: 'resource-class9-8',
        name: (
            <FormattedMessage
                defaultMessage="Face Detection to identify gender"
                description="Resource name"
                id="gui.resources.class9.8"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/Face Detection to identify gender.sb3',
        rawURL: '/static/resources/thumbnails/Face Detection to identify gender.png'
    },
    {
        id: 'resource-class9-10',
        name: (
            <FormattedMessage
                defaultMessage="AI - Facial expression detection"
                description="Resource name"
                id="gui.resources.class9.10"
            />
        ),
        tags: ['class9'],
        featured: true,
        sourcePath: '/static/resources/programs/AI - Facial expression detection.sb3',
        rawURL: '/static/resources/thumbnails/AI - Facial expression detection.png'
    },

    //     // CLASS 10 (Plceholders)
    //     {
    //         id: 'resource-class10-1',
    //         name: (
    //             <FormattedMessage
    //                 defaultMessage="Advanced AI Concepts"
    //                 description="Resource name"
    //                 id="gui.resources.class10.1"
    //             />
    //         ),
    //         tags: ['class10'],
    //         featured: true,
    //         sourcePath: '/static/resources/programs/Advanced AI Concepts.sb3',
    //         rawURL: '/static/resources/thumbnails/Advanced AI Concepts.png'
    //     },
    //     {
    //         id: 'resource-class10-2',
    //         name: (
    //             <FormattedMessage
    //                 defaultMessage="Machine Learning Simulation"
    //                 description="Resource name"
    //                 id="gui.resources.class10.2"
    //             />
    //         ),
    //         tags: ['class10'],
    //         featured: true,
    //         sourcePath: '/static/resources/programs/Machine Learning Simulation.sb3',
    //         rawURL: '/static/resources/thumbnails/Machine Learning Simulation.png'
    //     },
    //     {
    //         id: 'resource-class10-3',
    //         name: (
    //             <FormattedMessage
    //                 defaultMessage="Smart City Planning"
    //                 description="Resource name"
    //                 id="gui.resources.class10.3"
    //             />
    //         ),
    //         tags: ['class10'],
    //         featured: true,
    //         sourcePath: '/static/resources/programs/Smart City Planning.sb3',
    //         rawURL: '/static/resources/thumbnails/Smart City Planning.png'
    //     },
    //     {
    //         id: 'resource-class10-4',
    //         name: (
    //             <FormattedMessage
    //                 defaultMessage="Advanced Physics Simulation"
    //                 description="Resource name"
    //                 id="gui.resources.class10.4"
    //             />
    //         ),
    //         tags: ['class10'],
    //         featured: true,
    //         sourcePath: '/static/resources/programs/Advanced Physics Simulation.sb3',
    //         rawURL: '/static/resources/thumbnails/Advanced Physics Simulation.png'
    //     },
    //     {
    //         id: 'resource-class10-5',
    //         name: (
    //             <FormattedMessage
    //                 defaultMessage="Renewable Energy Interactive"
    //                 description="Resource name"
    //                 id="gui.resources.class10.5"
    //             />
    //         ),
    //         tags: ['class10'],
    //         featured: true,
    //         sourcePath: '/static/resources/programs/Renewable Energy Interactive.sb3',
    //         rawURL: '/static/resources/thumbnails/Renewable Energy Interactive.png'
    //     }
];
